<template>
	<div>
		<img alt='' :src="require(`@/v1-travel/assets/images/${src}.png`)"/>
		<strong>{{title}}</strong>
	</div>
</template>

<script>
export default {
	name: 'iconGroup',
	props: {
		title: String,
		src: String
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
	padding-right: 0.75em;
}
strong {
	line-height: 1.375em;
}
@media screen and (min-width: 1211px) {
	img {
		height: 2.5em;
	}
	strong {
		font-size: 1.125em;
		width: 9em;
	}
}
@media screen and (max-width: 1210px) {
	img {
		height: 2em;
	}
	div {
		margin-bottom: 0.5em;
		display: block;
	}
}
</style>
